import { render, staticRenderFns } from "./bet-report.vue?vue&type=template&id=07489928&scoped=true&"
import script from "./bet-report.vue?vue&type=script&lang=js&"
export * from "./bet-report.vue?vue&type=script&lang=js&"
import style0 from "./bet-report.vue?vue&type=style&index=0&id=07489928&scoped=true&lang=css&"
import style1 from "./bet-report.vue?vue&type=style&index=1&id=07489928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07489928",
  null
  
)

export default component.exports